var map = {
	"./DSC_1577.jpeg": 4772,
	"./DSC_1609.jpeg": 3332,
	"./DSC_2273.jpeg": 2656,
	"./DSC_2293.jpeg": 1032,
	"./DSC_2301.jpeg": 4,
	"./thumbnail.jpeg": 2764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2336;